export default __webpack_public_path__ + "static/char-s-sp01-zh-Hant-76790c5a54a5888cd1565f0ba43a0a8c.png";